module.exports = __webpack_public_path__ + "static/media/5efb017a8661d7beabf03e9d.7a8b6709.png";